import { translate } from '../../../common/utility/DisplayPrep';

const defaultUiConfig = {
    name: 'Codes',
    withActions: [],
    primaryKey: 'codeId',
    pageSize: 10,
    properties: {
        code: {
            name: 'Code',
            sortable: true,
            rowDisplay: true
        },
        codeId: {
            name: 'Code Id',
            sortable: true,
            rowDisplay: false
        },
        codeSystem: {
            name: 'Code System',
            sortable: true
        },
        codeSystemId: {
            name: 'Code System ID',
            sortable: true
        },
        displayName: {
            name: 'Display Name',
            sortable: true,
            nullable: false,
            rowDisplay: true
        },
        auditId: {
            name: 'Audit ID',
            sortable: true,
            rowDisplay: false
        },
        uuid: {
            rowDisplay: false,
            name: 'Uuid'
        },
        lastModId: {
            rowDisplay: false,
            name: 'Last Modified ID'
        },
        lastModDatetime: {
            rowDisplay: false,
            displayPrep: 'FullDate',
            name: 'Last Modified Datetime',
            additionalProperties: {
                Cell: ({ cell: { value } }) => {
                    return translate.ReadableDateTimeColumn(value);
                }
            }
        },
        createId: {
            rowDisplay: false,
            name: 'Create ID'
        },
        createDatetime: {
            rowDisplay: false,
            name: 'Create Datetime'
        }
    }
};

export default defaultUiConfig;
